import {
  CardOutlineIcon,
  HelpPathOutlineIcon,
  TimesOutlineIcon,
} from '@ikyucom/design-system-icons-react'
import * as Popover from '@radix-ui/react-popover'
import { useState } from 'react'
import { LabelNormal } from '~/components/LabelNormal'
import { css, cx, sva } from '~/styled-system/css'
import { vstack } from '~/styled-system/patterns'

export function CancelGuardLabel({ className }: { className?: string }) {
  return (
    // TODO: Label コンポーネントの方針議論中のため、方針決定したら Label コンポーネントを使うように修正する
    // border なし・背景色なしの Label コンポーネントを用意する予定
    // https://www.figma.com/design/4RphgTJS4xrTXmtSJS3ANB/RES_UI-Guideline?node-id=4973-5890&t=P4E1ZCGVyrlKWV8H-0
    <p className={cx(css({ display: 'flex', alignItems: 'center', color: 'gray.700' }), className)}>
      <CardOutlineIcon width={12} height={12} className={css({ mr: '1' })} />
      <span className={css({ fontSize: 'xs', fontWeight: 'bold' })}>
        キャンセル料のみカード決済
      </span>
    </p>
  )
}

const styles = sva({
  slots: ['popover', 'content', 'close'],
  base: {
    popover: vstack.raw({
      gap: '2',
      alignItems: 'center',
    }),
    content: {
      flex: '1',
      bg: 'white',
      shadow: 'outline.lg',
      borderRadius: 'md',
      p: '3',
      color: 'gray.800',
      width: '[300px]',
    },
    close: {
      position: 'fixed',
      right: '3',
      top: '3',
      color: 'gray.700',
      padding: '1',
      rounded: 'sm',
      transition: '[background-color 0.2s]',
      _hover: {
        background: 'gray.100',
        cursor: 'pointer',
      },
    },
  },
})

export function CancelGuardLabelWithInformation() {
  const [open, setOpen] = useState(false)
  const classes = styles()

  const closePopup = () => setOpen(false)
  const openPopup = () => setOpen(true)

  return (
    <Popover.Root open={open}>
      <Popover.Trigger onClick={openPopup}>
        <LabelNormal text="" className={css({ color: 'gray.700' })}>
          <CardOutlineIcon width={12} height={12} className={css({ mr: '1' })} />
          キャンセル料のみカード決済
          <HelpPathOutlineIcon width={12} height={12} className={css({ ml: '1' })} />
        </LabelNormal>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          onInteractOutside={closePopup}
          align="end"
          alignOffset={-60}
          className={classes.content}
        >
          <Popover.Arrow width={12} height={6} className={css({ fill: 'white' })} />
          <div className={classes.popover}>
            <div>
              <p className={css({ fontWeight: 'bold' })}>キャンセル料のみカード決済</p>
              <span className={classes.close} onClick={closePopup} aria-label="閉じる">
                <TimesOutlineIcon width={14} height={14} />
              </span>
            </div>
            <p className={css({ fontSize: 'sm' })}>
              ご予約の取り消しによりキャンセル料が発生した場合、予約時にご登録いただくクレジットカードにてキャンセル料を決済します。
            </p>
          </div>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  )
}
